<template>
  <!-- Название -->
  <div class="lesson-name">
    <strong>{{ lesson.time }}</strong> {{ lesson.predm }}
  </div>
</template>

<script>
export default {
  name: 'lessonName',
  props: {
    lesson: Object
  }
}
</script>

<style scoped>
.lesson-name {
  padding-right: 32px;
}
</style>
